<!--
 * @Author: TangYuxuan
 * @Date: 2020-10-12 18:03:46
 * @LastEditTime: 2020-10-29 19:16:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\src\components\writing\duplicateCheck.vue
-->
<!-- 实时查重 -->
<template>
  <div class="check">
    <div class="box">
      <div class="title_row">
        <span class="left_span"
          ><span class="shu"></span> 标题：{{ title }}
        </span>
      </div>
      <div class="loadingbox">
        <p
          style="margin-top:40px"
          v-if="dataList == null"
          v-loading="loading"
          element-loading-text="正在努力进行查重"
        >
          {{ checkNoticeMsg }}
        </p>
        <p style="padding-top: 80px;" v-if="loading && dataList == null">
          等待的时间可以看看论文资料哦
        </p>
        <div
          class="lookdata"
          v-if="dataList != null"
          v-loading="loading && dataList != null"
          element-loading-text="正在努力进行查重"
        >
          <p>查重时间：{{ dataList.createTime }}</p>
          <div style="margin-top:24px">
            重复率：
            <div class="progress">
              <div
                :class="dataList.similar - 0 > 30 ? 'Mcolor' : 'no'"
                :style="
                  'width:' +
                    (dataList.similar - 0) +
                    '%;height:8px;background:' +
                    color2 +
                    ' ;border-radius: 4px;'
                "
              ></div>
            </div>
            <span
              :style="
                dataList.similar - 0 > 30
                  ? 'color: #FF5959;margin-left:10px;'
                  : ' color: #66686E;margin-left:10px;'
              "
              >{{ dataList.similar - 0 }}%</span
            >
          </div>
          <p>
            重复字数：{{ dataList.similarWordCount || 0 }} / 总字数：{{
              dataList.wordCount || 0
            }}
          </p>
        </div>
      </div>
      <div class="btn_box">
        <div
          style="display: flex; flex-direction: column; justify-content: center;align-items: center;"
        >
          <button
            class="get_check"
            v-if="loading"
            :style="loading ? 'background: #C4C9CE;' : ''"
          >
            实时查重
          </button>
          <button
            class="get_check"
            @click="get_check()"
            v-if="!loading"
            :style="loading ? 'background: #C4C9CE;' : ''"
            :disabled="loading"
          >
            实时查重
          </button>
          <span class="num" v-if="!checkLimit.isYearVip && checkTimes > 0"
            >（剩余<span>{{ checkTimes }}</span
            >次查重机会）</span
          >
          <span
            style="padding-top:10px"
            v-if="checkLimit.isYearVip && !checkLimit.vipType"
          >
            <span
              style="display:inline-block; background: #c7a468; padding: 0 3px"
            >
              <img
                src="../../../static/images/vip_small.png"
                width="60%"
                height="60%"
              />
            </span>
            {{ vipTypes[checkLimit.vipType - 1] }}
          </span>
        </div>
        <button class="getlist" @click="getlist">查重记录</button>
      </div>

      <div class="title_row">
        <span class="left_span"><span class="shu"></span>相似源</span>
      </div>

      <div class="non404" v-if="reclList == 0">
        <div>
          <img
            class="userimg"
            src="/static/images/non404_xiangsiyuan.png"
            alt=""
            srcset=""
          />
          <p>选中左侧红色句子查看相似源</p>
          <p style="margin-top:21px">
            （<span style="color:red">红色</span>文字表示重复的部分，<span
              style=" color: #5576BD;"
              >蓝色</span
            >文字表示修改过的部分）
          </p>
        </div>
      </div>
      <template v-if="reclList != 0">
        <div class="list">
          <div class="rowSpan">您的句子</div>
          <p class="text">{{ reclList.sentence }}</p>
          <div
            class="list_row"
            v-for="(item, index) in reclList['sources']"
            :key="index"
          >
            <div class="row">
              <span class="row_num">{{ index + 1 }}相似源</span>
              <span class="vs_pk"
                >相似度： <span>{{ item.similarityPercentage }}</span>
              </span>
            </div>

            <div class="rowSpan"></div>
            <div>
              <p class="text" v-html="item.text"></p>
              <p class="Author">篇名：{{ item.title }}</p>
              <p class="Author">作者：{{ item.author }}</p>
              <p class="Author">来源：{{ item.source }}</p>
            </div>
          </div>
        </div>
      </template>
    </div>
    <el-dialog title="提交查重" width="500px" 
      :close-on-click-modal= "false"
      :visible.sync="checkDialogShow"
      :before-close="handleCloseCheckDialog"
      >
      <div class="check-payment-info">
        <div>
          <span>字数：</span>
          <span>{{ checkSubmitResult.wordCount }}字</span>
        </div>
        <div>
          <span>单价：</span>
          <span
            ><span class="number-style">{{ checkSubmitResult.price }}</span
            >学书币/万字</span
          >
        </div>
        <div>
          <span>合计：</span>
          <span v-if="!checkSubmitResult.free">
            <span class="number-style">{{ checkSubmitResult.payPoint }}</span
            >学术币
          </span>
          <span v-if="checkSubmitResult.free">
            <span class="number-style">0</span
            ><span style="text-decoration:line-through"
              >{{ checkSubmitResult.payPoint }}学术币</span
            >
          </span>
        </div>
      </div>
      <div style="display:flex; justify-content: center; margin: 20px auto;">
        余额：{{ checkSubmitResult.userPoint }}学术币
      </div>
      <div style="display:flex; justify-content: center;">
        <button
          @click="checkPay"
          class="check-primary-btn"
          v-if="checkSubmitResult.free && checkSubmitResult.freeType == 1"
        >
          <span class="check-btn-text">免费试用</span>
        </button>
        <button
          @click="checkPay"
          class="check-primary-btn"
          v-if="!checkSubmitResult.free && checkSubmitResult.pointEnough"
        >
          <span class="check-btn-text">立即支付</span>
        </button>
        <button
          @click="goVip"
          class="check-glod-btn"
          style="margin-right:16px"
          v-if="!checkSubmitResult.free && !checkSubmitResult.pointEnough"
        >
          <span class="check-btn-text">成为年度会员</span>
        </button>
        <button
          @click="goRecharge"
          class="check-primary-btn"
          v-if="!checkSubmitResult.free && !checkSubmitResult.pointEnough"
        >
          <span class="check-btn-text">立即充值</span>
        </button>
        <button
          @click="checkPay"
          class="check-glod-btn"
          v-if="checkSubmitResult.free && checkSubmitResult.freeType != 1"
        >
          <div class="check-btn-text">
            <img
              src="../../../static/images/vip_small.png"
              style="margin-right:5px"
            />
            <span style="display:inline-block; ">免费使用 </span>
          </div>
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["id", "title", "realId"],
  data: function() {
    return {
      look: false,
      checkTimes: 0,
      loading: false,
      listData: [],
      customColors: [
        {
          color: "#f56c6c",
          percentage: 20
        },
        {
          color: "#e6a23c",
          percentage: 40
        }
      ],
      dataList: null,
      color: "linear-gradient(90deg, #FF5959 0%, #FF8686 100%)",
      color2: "linear-gradient(90deg, #5576BD 0%, #7395DE 100%);",
      colornum: 40,
      checkTime: "",
      reclList: [],
      checkLimit: {},
      vipTypes: ["年度会员免费使用", "终身会员免费使用", "机构会员免费使用"],
      checkDialogShow: false,
      checkSubmitResult: {},
      isCheckPay: false,
      checkNoticeMsg: this.$root.stateType.cctext
    };
  },
  components: {},
  watch: {
    realId: function(val) {
      this.reclList = this.listData[this.realId];
    }
  },
  mounted: function() {
    this.initData();
    this.checkDetail();
  },
  beforeDestroy() {
    clearInterval(this.checkTime);
  },
  methods: {
    /**
     * 实时查重
     */
    // get_check: function () {
    //     let _this = this
    //     if (this.checkTimes == 0) {
    //         this.$confirm('<p style="text-align: center;margin-bottom: 10px;color: #66686E;">您的2次查重体验机会已耗尽，购买会员后可无限次查重？</p>', '温馨提示', {
    //             showInput: false,
    //             dangerouslyUseHTMLString: true,
    //             cancelButtonClass: "myno",
    //             confirmButtonClass: "govip",
    //             confirmButtonText: "立即开通",
    //             cancelButtonText: "暂不开通",
    //         }).then(() => {
    //             _this.$parent.goVip();
    //         }).catch();
    //     } else {
    //         _this.loading = true;

    //         _this.api.checkSubmit(this.id).then(res => {
    //             _this.loading = false;
    //             if (res.code == 2003) {
    //                 setTimeout(() => {
    //                     _this.$prompt('<p style="text-align: center;margin-bottom: 10px;color: #66686E;font-size: 12px;">' + res.msg + '</p>', '温馨提示', {
    //                         showInput: false,
    //                         dangerouslyUseHTMLString: true,
    //                         cancelButtonClass: "myno",
    //                         confirmButtonClass: "next",
    //                         confirmButtonText: "我知道了",
    //                     }).then(res => {
    //                         _this.loading = false
    //                         _this.$root.stateType.msg = false
    //                     }).catch(() => {});;
    //                 }, 500);

    //             } else {
                   
    //             }

    //         })
    //     }

    // },

    get_check: function() {
      if (this.$root.stateType.msg) {

      } else {
        
         let loadingMask = document.getElementsByClassName("el-loading-mask")[1];
         if (loadingMask) {
            this.loading = true;
            loadingMask.style = "background:none"
            loadingMask.parentElement.style = "color: #fff;z-index:1"
         } else {
             this.loading = false;
         }
          let _this = this;
          this.api.checkSubmit(this.id).then(res => {
            if (res.code == 0) {
              this.checkSubmitResult = res.data;
              this.checkDialogShow = true;
            } else if(res.code == 2002 || res.code == 2003) {
                setTimeout(() => {
                    _this.$prompt('<p style="text-align: center;margin-bottom: 10px;color: #66686E;font-size: 12px;">' + res.msg + '</p>', '温馨提示', {
                        showInput: false,
                        dangerouslyUseHTMLString: true,
                        cancelButtonClass: "myno",
                        confirmButtonClass: "next",
                        confirmButtonText: "我知道了",
                    }).then(res => {
                        _this.loading = false
                        _this.$root.stateType.msg = false
                    }).catch(() => {});;
                }, 2000);
            }
          });
      }
    },

    getlist: function() {
      this.$emit("golist");

    },
    /**
     * 初始化获取查重数据
     */
    initData: function() {
      this.api.checkLimit().then(res => {
        if (res.code == 0) {
          this.checkTimes = res.data.checkTimes;
          this.checkLimit = res.data;
        }
      });
    },
    /**
     * 更新查重
     */
    listInit() {
      this.api.checkLimit().then(res => {
        if (res.code == 0) {
          this.checkTimes = res.data.checkTimes;
          this.get_check();
        }
      });
    },
    checkDetail() {
      this.loading = true;
      this.api
        .checkDetail({
          articleId: this.id
        })
        .then(res => {
          if (res.code == 0) {
            if (res.data.checkState == 3) {
              clearInterval(this.checkTime);
              this.dataList = res.data;
              this.loading = false;
              let arr = ([] = JSON.parse(res.data.similarJson || "[]"));
              this.listData = JSON.parse(res.data.similarJson || "[]");
              this.reclList = this.listData[this.realId] || [];
              this.$root.stateType.msg = false;
              document
                .getElementById("editor")
                .setAttribute("contenteditable", "true");
              if (!res.data.cancel) {
                this.$emit("gethtml", "true");
              }
            } else {
              // this.loading = true;
              this.checkNoticeMsg = "论文正在检测中";
              if (this.$root.stateType.msg) {
                this.checkTime = setTimeout(() => {
                  this.checkDetail();
                }, 3000);
              } else {
                this.loading = false;
              }
            }
          } else {
            this.$root.stateType.msg = false;
            this.loading = false;
          }
        });
    },

    /** 支付查重 */
    checkPay: function() {
      let _this = this;
      this.loading = true;
      this.api
        .checkPay({
          id: this.checkSubmitResult.id
        })
        .then(res => {
          if (res.code == 0) {
            this.checkDialogShow = false;
            this.isCheckPay = true;
            this.resetLodingMask();
            this.checkNoticeMsg = "正在提交中"
            this.checkDetail();
          } 
        });
    },
    /** 跳转会员充值 */
    goVip: function() {
      this.checkDialogShow = false;
      this.$parent.goVip();
    },
    /** 跳转学术币充值 */
    goRecharge: function() {
      this.checkDialogShow = false;
      this.$parent.goVip("second");
    },
    /** 处理支付弹框的关闭按钮 */
    handleCloseCheckDialog(done) {
      if(!this.isCheckPay) {
        this.loading = false;
      } else {
        this.loading = true;
      }
      this.resetLodingMask();
      done();
    },
    //重置查重区的加载样式
    resetLodingMask() {
      if(document.getElementsByClassName("el-loading-mask")[1]) {
        document.getElementsByClassName("el-loading-mask")[1].parentElement.style = "color:#989da2;margin-top:40px";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-loading-text {
  color: #06c;
}

.mgs_golink {
  position: fixed;
  z-index: 99999;
  left: 40%;
  top: 54px;
  background: #ffffff;
  transition: top 0.3s;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  color: #66686e;
  border: 1px solid #cccccc;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);

  button {
    color: #c79758;
    background: none;
    border: none;
  }
}

.noshow {
  position: fixed;
  z-index: 0;
  left: 40%;
  top: -100px;
  background: #ffffff;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  color: #66686e;
  border: 1px solid #cccccc;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
}

.check {
  padding-left: 40px;

  .non404 {
    text-align: center;
    margin-top: 140px;

    img {
      height: 111px;
    }

    p {
      margin-top: 38px;
      font-size: 14px;
      color: #989ea2;
      line-height: 22px;
    }
  }

  .list {
    height: 50vh;
    overflow: auto;
    padding-right: 40px;

    .list_row {
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #f5f6fa;
    }

    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .row_num {
        width: 80px;
        height: 20px;
        background: #a1b5e0;
        border-radius: 2px 10px 10px 2px;
        color: #ffffff;
        text-align: center;
        font-weight: bold;
      }

      .vs_pk {
        font-size: 16px;
        font-weight: bold;
        color: #333439;

        span {
          font-size: 18px;
          font-weight: bold;
          color: #ff5959;
        }
      }
    }

    .rowSpan {
      font-size: 14px;
      font-weight: bold;
      color: #66686e;
      margin-top: 19px;
    }

    .text {
      margin-top: 12px;
      font-size: 14px;
      font-weight: 400;
      color: #66686e;
      margin-bottom: 20px;
    }

    .Author {
      font-size: 14px;
      color: #989da2;
      margin-top: 12px;
    }
  }

  .lookdata {
    text-align: left;
    padding-left: 16px;

    p {
      margin-top: 24px;
    }

    div {
      display: flex;
      align-items: center;

      .progress {
        background: #ece1e1;
        width: 100px;
        height: 8px;
        border-radius: 4px;
        overflow: hidden;
      }
    }
  }

  .Mcolor {
    background: linear-gradient(90deg, #ff5959 0%, #ff8686 100%) !important;
  }

  .box {
    height: calc(100vh - 60px);
    overflow: auto;

    .title_row {
      color: $btnc;
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      padding-right: 40px;

      .left_span {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: bold;

        .shu {
          border-left: 4px solid $btnc;
          height: 18px;
          display: inline-block;
          margin-right: 12px;
        }
      }
    }

    .loadingbox {
      text-align: center;
      color: #989da2;
      height: 158px;
    }

    .num {
      font-size: 12px;
      font-weight: 400;
      color: #989da2;

      span {
        color: red;
      }
    }

    .btn_box {
      text-align: center;
      display: flex;
      justify-content: center;

      .get_check {
        color: #ffffff;
        width: 90px;
        height: 30px;
        background: linear-gradient(0deg, #5576bd 0%, #6686c8 100%);
        border-radius: 15px;
        border: none;
      }

      .getlist {
        width: 90px;
        height: 30px;
        border-radius: 15px;
        color: $btnc;
        background: none;
        margin-left: 16px;
      }
    }
  }

  /deep/ .el-dialog__title{
    font-weight: 800;
  }

  .check-payment-info {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 460px;
    height: 141px;
    background: #f8f8fa;
    opacity: 1;
    border-radius: 2px;
    div {
      margin-left: 146px;
      span:nth-child(1) {
        padding-right: 27px;
      }
      .number-style {
        font-size: 24px;
        font-weight: 400;
        color: #da521b;
        margin-right: -20px;
      }
    }
  }

  .check-primary-btn {
    width: 134px;
    height: 36px;
    background: #5576bd;
    opacity: 1;
    border-radius: 18px;
    border: none;
  }

  .check-glod-btn {
    width: 134px;
    height: 36px;
    background: #c79758;
    opacity: 1;
    border-radius: 18px;
    border: none;
  }

  .check-btn-text {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 12px;
    color: #ffffff;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/writing/duplicateCheck.vue